import { Component, Input } from '@angular/core';

@Component({
    selector: 'qms-management-navigation-menu',
    templateUrl: './management-navigation-menu.component.html'
})
export class ManagementNavigationMenuComponent {
    @Input()
    public category: string;

    @Input()
    public selectedElement: any;

    public onSelectedChanged(event: any) {
        this.selectedElement = event;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/management-navigation-menu/management-navigation-menu.component.ts